import * as React from "react";

import { Viewport, ViewSmall, ViewMedium } from "bernie-view";
import { useProvidedState } from "@shared-ui/provided-state-context";

import { WizardTabbed } from "components/shared/StorefrontWizard/WizardTabbed/WizardTabbed";
import { WizardHero } from "components/shared/StorefrontWizard/WizardHero/WizardHero";
import { FlexComponent } from "src/typings/flexFramework/FlexComponent";
import { ClientWizardStateStore } from "src/stores/wizard/ClientWizardStateStore";

export const StorefrontWizardRegionBEXView = (props: {
  regionClassname: string;
  heroImageSrc: string;
  isSingleLobWithTitle: boolean;
  cardClass: string;
  heroImageFigureClassNames?: string;
  isStorefrontPage: boolean;
  context: any;
  trackOnChangeTab: (tab: string) => void;
  wizardFormChildren: React.ReactElement[];
  wizardLOBs: FlexComponent[];
  wizardState: ClientWizardStateStore;
  otherFormChildren: React.ReactElement[];
}) => {
  const [data] = useProvidedState();
  const isTripsHeroActive = data?.tripsHero?.isRendered ?? false;
  const className = !isTripsHeroActive ? "StorefrontWizardRegionBEX" : "StorefrontWizardRegionBEXTripsHero";

  return (
    <div className={`${className} ${props.regionClassname}`} data-testid="storefront-region">
      <div data-testid="main-region">
        <Viewport>
          <ViewSmall>
            <WizardTabbed
              isStorefrontPage={props.isStorefrontPage}
              wizardLOBs={props.wizardLOBs}
              context={props.context}
              wizardFormChildren={props.wizardFormChildren}
              trackOnChangeTab={props.trackOnChangeTab}
            />
          </ViewSmall>
          <ViewMedium>
            <WizardHero
              heroImageSrc={props.heroImageSrc}
              isSingleLobWithTitle={props.isSingleLobWithTitle}
              cardClass={`all-cell-1-1 elevation-4 ${props.cardClass}`}
              heroImageFigureClassNames={`bexHeroImageFigure ${props.heroImageFigureClassNames}`}
              isStorefrontPage={props.isStorefrontPage}
              context={props.context}
              trackOnChangeTab={props.trackOnChangeTab}
              wizardFormChildren={props.wizardFormChildren}
              wizardLOBs={props.wizardLOBs}
              wizardState={props.wizardState}
            />
          </ViewMedium>
        </Viewport>

        {props.otherFormChildren}
      </div>
    </div>
  );
};
